<template>
  <div class="inputSelectWrap">
    <el-input v-model="code" :disabled="disabled" v-regexFilter="$numRegex" :placeholder="$t('common.placeholder.enter')">
      <el-select v-model="prefix" :disabled="disabled" slot="prepend">
        <template slot="prefix" v-if="prefix">+</template>
        <el-option v-for="item in globalFormatList('prefixList')" :key="item.label" :value="item.value">{{ item.label }}</el-option>
      </el-select>
    </el-input>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  name: "PrefixPhone",
  props: {
    value: {
      type: String,
      default: () => "",
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      prefix: "",
      code: "",
      isFirstLoad: true, //增加一个标记位，记录是否已经完成过初始化
    };
  },
  computed: {
    ...mapState("constant", ["prefixList"]),
    ...mapGetters("constant", ["globalFormatList"]),
    // 关键逻辑：将内部的两个字段合并为一个符合要求的字符串
    combinedValue() {
      if (this.prefix && this.code) return `${this.prefix}-${this.code}`;
      if (this.code) return `-${this.code}`; // 有号码没前缀
      if (this.prefix) return `${this.prefix}-`; // 有前缀没号码
      return "";
    },
  },
  watch: {
    // 【回显】监听外部传入的 value 变化
    value: {
      handler(newVal) {
        if (newVal) {
          if (newVal.includes("-")) {
            const parts = newVal.split("-");
            this.prefix = parts[0] || "";
            this.code = parts[1] || "";
          } else {
            // 如果传入的数据没有"-"号，说明传值错误，直接重置为空
            this.prefix = "";
            this.code = "";
          }
        } else {
          if (this.isFirstLoad) {
            // 如果回显时为空，前缀默认选中第一个
            const defaultFirstOne = this.prefixList[0]?.value || "";
            this.prefix = defaultFirstOne;
            this.code = "";
          } else {
            this.prefix = "";
            this.code = "";
          }
        }
        // 防止后续清空时再次触发
        this.isFirstLoad = false;
      },
      immediate: true, // 组件创建时立即执行一次
    },
    // 【触发同步】当合并后的值变化时，通知父组件更新 v-model
    combinedValue(newVal) {
      this.$emit("input", newVal);
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.inputSelectWrap {
  width: 100%;

  ::v-deep {
    .el-input {
      width: 100% !important;

      .el-input-group__prepend {
        padding: 0 0 0 4px !important;
        background-color: #fff;
      }

      .el-input__prefix {
        color: #909399 !important;
      }

      .el-input--prefix {
        .el-input__inner {
          text-indent: 16px !important;
        }
      }
    }
  }
}
</style>
